export class FileAttachment {
    FileID: string;
    FileName: string;
    FileSize: number;
    FileType: string;
    UserID: string;
    PortalID: number;
    UploadBy: number;
    UploadByDisplayName: string;
    UploadDate: Date;
    DisplayName: string;
}